import { CategoryIcon } from './GameIcon';
import './CategoryMilestoneBadge.css';

export default function CategoryMilestoneBadge({ categoryKey, level, className = '', label = '' }) {
  return <span className={`category-milestone-badge category-milestone-badge--${level} ${className}`} role={label ? 'img' : undefined} aria-label={label || undefined}>
    <span className="category-milestone-badge__core"><CategoryIcon categoryKey={categoryKey} alt="" /></span>
    <span className="category-milestone-badge__level" aria-hidden="true">{level}</span>
  </span>;
}
